import React, { useCallback, useState } from "react";
import { Form, NumberInput, TextInput, Checkbox, CheckboxGroup, RadioButtonGroup, useTranslator } from "@sia/style-guide";
import Introduction from "./Introduction";
// import erpAdapter from "adapters/ERPAdapter";

const BBFForm = () => {
  const translate = useTranslator();
  const [formValues, _setFormValues] = useState({});
  const [errors, setErrors] = useState({});

  const setFormValues = useCallback((label, value) => {
    _setFormValues((prevState) => ({
      ...prevState,
      [label]: value,
    }));
  }, []);
  const formError = "";
  const submitForm = () => {
    setErrors();
    let errors_aux = {};
    setErrors((prevState) => ({
      ...prevState,
      employees_number: true,
    }));
    if (!formValues["subordinate_employees"]) {
      errors_aux["subordinate_employees"] = translate("account.customer-data.bbf.form.question1.subordinate_employees.error");
    } else {
      if (formValues["subordinate_employees"] === "assumed") {
        if (formValues["employees_number"] === "" || formValues["employees_number"] === undefined) {
          errors_aux["employees_number"] = translate("account.customer-data.bbf.form.question1.employees_number.error");
        }
      }
      if (formValues["subordinate_employees"] === "art5") {
        if (formValues["firmenname"] === "" || formValues["firmenname"] === undefined) {
          errors_aux["firmenname"] = translate("account.customer-data.bbf.form.question1.firmenname.error");
        }
        if (formValues["uid1"] !== "" && formValues["uid1"] !== undefined) {
          if (formValues["uid2"] === "" || formValues["uid2"] === undefined || formValues["uid3"] === "" || formValues["uid3"] === undefined) {
            errors_aux["uid"] = translate("account.customer-data.bbf.form.question1.uid.error");
            if (formValues["uid2"] === "" || formValues["uid2"] === undefined) errors_aux["uid2"] = true;
            if (formValues["uid3"] === "" || formValues["uid3"] === undefined) errors_aux["uid3"] = true;
          }
        }
      }
    }
    if (!formValues["ausbildung"]) {
      errors_aux["ausbildung"] = translate("account.customer-data.bbf.form.question2.ausbildung.error");
    } else {
      if (formValues["ausbildung"] === "yes") {
        if (formValues["ausbildung_items"] === undefined || formValues["ausbildung_items"]?.length === 0) {
          errors_aux["ausbildung_items"] = translate("account.customer-data.bbf.form.question2.ausbildung-items.error");
        }
      }
    }
    if (formValues["association_items"] === undefined || formValues["association_items"]?.length === 0) {
      errors_aux["association_items"] = translate("account.customer-data.bbf.form.question3.association-items.error");
    }
    setErrors(errors_aux);
    if (Object.keys(errors_aux).length === 0) {
      const { uid1, uid2, uid3, ...rest } = formValues;
      let payLoad = {
        ...rest,
        ausbildung_items: formValues.ausbildung_items?.join(","),
        association_items: formValues.association_items?.join(","),
      };
      if (formValues["uid1"] !== "") {
        payLoad["uid"] =
          "CHE-" +
          String(formValues["uid1"]).padStart(3, "0") +
          "." +
          String(formValues["uid2"]).padStart(3, "0") +
          "." +
          String(formValues["uid3"]).padStart(3, "0");
      }
      console.log("formValues:", payLoad);
      //   erpAdapter.fetch("POST", "bbf/add", payLoad, (data) => {
      //     console.log("data:", data);
      //   });
    }
  };
  return (
    <div>
      <Introduction />
      <Form multiPage primaryButtonLabel={translate("account.customer-data.bbf.form.save-button")} onClickPrimaryButton={submitForm}>
        <div className="questions">
          <Question1 errors={errors} formValues={formValues} setFormValues={setFormValues} />
          <Question2 errors={errors} formValues={formValues} setFormValues={setFormValues} />
          <Question3 errors={errors} formValues={formValues} setFormValues={setFormValues} />
        </div>
        <p className="sia-text-07">{formError}</p>
      </Form>
    </div>
  );
};

const Question1 = ({ formValues, setFormValues, errors }) => {
  const translate = useTranslator();

  const items = [
    { value: "assumed", label: translate("account.customer-data.bbf.form.question1.assumed") },
    { value: "art4", label: translate("account.customer-data.bbf.form.question1.art4") },
    { value: "art5", label: translate("account.customer-data.bbf.form.question1.art5") },
  ];
  return (
    <div className="bbf-form-group">
      <RadioButtonGroup
        name={"subordinate_employees"}
        title={translate("account.customer-data.bbf.form.question1.title")}
        items={items}
        value={formValues["subordinate_employees"]}
        handleCheckboxChange={(value) => {
          setFormValues("subordinate_employees", value);
          setFormValues("employees_number", undefined);
          setFormValues("outsourced", undefined);
          setFormValues("firmenname", undefined);
          setFormValues("uid1", undefined);
          setFormValues("uid2", undefined);
          setFormValues("uid3", undefined);
        }}
      />
      {formValues["subordinate_employees"] === "assumed" && (
        <div className="sia-padding-01-top">
          <NumberInput
            id="employees_number"
            label={translate("account.customer-data.bbf.form.question1.employees-number")}
            required
            onChange={(e) => {
              setFormValues("employees_number", e.target.value);
            }}
            invalidText={errors["employees_number"]}
          />
        </div>
      )}
      {formValues["subordinate_employees"] === "art5" && (
        <div>
          <Checkbox
            id={"outsourced"}
            label={translate("account.customer-data.bbf.form.question1.outsourced")}
            value={formValues["outsourced"] || false}
            onChange={(event, value) => setFormValues("outsourced", value)}
          />
          {formValues["outsourced"] && (
            <div>
              <TextInput
                id="firmenname"
                label={translate("account.customer-data.bbf.form.question1.firmenname")}
                required
                onChange={(e) => setFormValues("firmenname", e.target.value)}
                invalidText={errors["firmenname"]}
              />
              <p className="bx--label">{translate("account.customer-data.bbf.form.question1.uid")}</p>
              <div id="input-group">
                <p className="che">CHE -</p>
                <div id="input-group">
                  <NumberInput
                    id="uid1"
                    label=""
                    onChange={(e) => {
                      setFormValues("uid1", e.target.value);
                    }}
                    min={0}
                    max={999}
                  />
                  <NumberInput
                    id="uid2"
                    label=""
                    onChange={(e) => {
                      setFormValues("uid2", e.target.value);
                    }}
                    invalidText={!!errors["uid2"]}
                    min={0}
                    max={999}
                  />
                  <NumberInput
                    id="uid3"
                    label=""
                    onChange={(e) => {
                      setFormValues("uid3", e.target.value);
                    }}
                    invalidText={!!errors["uid3"]}
                    min={0}
                    max={999}
                  />
                </div>
              </div>
              {errors["uid"] && <p className="sia-text-07 sia-margin-01-top">{errors["uid"]}</p>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
const Question2 = ({ formValues, setFormValues, errors }) => {
  const translate = useTranslator();

  const educationItems = [
    { value: "yes", label: translate("account.customer-data.bbf.form.question2.yes") },
    { value: "no", label: translate("account.customer-data.bbf.form.question2.no") },
  ];
  const educationItemsLevel2 = [
    { value: "architektur", label: translate("account.customer-data.bbf.form.question2.architektur") },
    { value: "ingenieurbau", label: translate("account.customer-data.bbf.form.question2.ingenieurbau") },
    { value: "innenarchitektur", label: translate("account.customer-data.bbf.form.question2.innenarchitektur") },
    { value: "landschaftsarchitektur", label: translate("account.customer-data.bbf.form.question2.landschaftsarchitektur") },
    { value: "raumplanung", label: translate("account.customer-data.bbf.form.question2.raumplanung") },
  ];
  const handleCheckboxChange = (id, value) => {
    if (value) {
      setFormValues("ausbildung_items", [...(formValues["ausbildung_items"] || []), id]);
    } else {
      setFormValues(
        "ausbildung_items",
        (formValues["ausbildung_items"] || []).filter((item) => item !== id)
      );
    }
  };
  return (
    <div className="bbf-form-group">
      <RadioButtonGroup
        name={"ausbildung"}
        title={translate("account.customer-data.bbf.form.question2.title")}
        items={educationItems}
        value={formValues["ausbildung"]}
        handleCheckboxChange={(value) => setFormValues("ausbildung", value)}
      />

      {formValues["ausbildung"] === "yes" && (
        <CheckboxGroup
          items={educationItemsLevel2}
          formValues={formValues["ausbildung_items"]}
          handleCheckboxChange={(value, checked) => handleCheckboxChange(value, checked)}
          error={errors["ausbildung_items"]}
        ></CheckboxGroup>
      )}
    </div>
  );
};

const Question3 = ({ formValues, setFormValues, errors }) => {
  const translate = useTranslator();
  const associationItems = [
    { value: "bsa", label: translate("account.customer-data.bbf.form.question3.bsa") },
    { value: "bsla", label: translate("account.customer-data.bbf.form.question3.bsla") },
    { value: "fsai", label: translate("account.customer-data.bbf.form.question3.fsai") },
    { value: "fsu", label: translate("account.customer-data.bbf.form.question3.fsu") },
    { value: "sia", label: translate("account.customer-data.bbf.form.question3.sia") },
    { value: "suisse", label: translate("account.customer-data.bbf.form.question3.suisse") },
    { value: "vsi", label: translate("account.customer-data.bbf.form.question3.vsi") },
    { value: "vssm", label: translate("account.customer-data.bbf.form.question3.vssm") },
    { value: "none", label: translate("account.customer-data.bbf.form.question3.none") },
  ];
  const handleCheckboxChange = (id, value) => {
    if (value) {
      setFormValues("association_items", [...(formValues["association_items"] || []), id]);
    } else {
      setFormValues(
        "association_items",
        (formValues["association_items"] || []).filter((item) => item !== id)
      );
    }
  };
  return (
    <div id="association_items" className="bbf-form-group">
      <CheckboxGroup
        items={associationItems}
        formValues={formValues["association_items"]}
        handleCheckboxChange={(value, checked) => handleCheckboxChange(value, checked)}
        error={errors["association_items"]}
        title={translate("account.customer-data.bbf.form.question3.title")}
      ></CheckboxGroup>
    </div>
  );
};
export default BBFForm;
